// extracted by mini-css-extract-plugin
export default {"rootContainer":"root_rootContainer__foKEu","main_admin":"root_main_admin__zysCx","header_admin":"root_header_admin__YO1PZ"};